const Labdata = [
    {
        id: 0,
        name: 'GIA',
        code: 'GIA',
    },
    {
        id: 1,
        name: 'IGI',
        code: 'IGI',
    },
    {
        id: 2,
        name: 'GCAL',
        code: 'GCAL',
    }
]
const Type = [
    {
        id: 0,
        name: 'CVD',
        code: 'CVD',
    },
    {
        id: 1,
        name: 'HPHT',
        code: 'HPHT',
    }
]

export { Labdata, Type };